var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShimmer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 342.171,
    height: 92.972,
    viewBox: "0 0 342.171 92.972",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1305",
    "data-name": "Rectangle 1305",
    width: 342.171,
    height: 92.972,
    rx: 11.867,
    transform: "translate(417.915 1838)",
    fill: "#fff",
    stroke: "rgba(112,112,112,0.3)",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-417.915 -1838)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shimmer_Logo",
    transform: "translate(453.496 1845.218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52563",
    "data-name": "Path 52563",
    d: "M57.174,22.922a18.8,18.8,0,0,0-27.249-.38,20.462,20.462,0,0,0-.367,28.22l4.88-4.92A13.272,13.272,0,0,1,34.7,27.567a12.2,12.2,0,0,1,17.646.218Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52564",
    "data-name": "Path 52564",
    d: "M25.109,61.449a18.8,18.8,0,0,0,27.249.38,20.462,20.462,0,0,0,.367-28.22l-4.88,4.919A13.272,13.272,0,0,1,47.58,56.8a12.2,12.2,0,0,1-17.646-.218Z",
    transform: "translate(-0.353 -5.834)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52565",
    "data-name": "Path 52565",
    d: "M106.927,53.411l-3.312,3.209a15.042,15.042,0,0,0,10.367,4.174,12.2,12.2,0,0,0,6.964-1.93,6.034,6.034,0,0,0,2.79-5.228,7.371,7.371,0,0,0-1.52-4.779q-1.633-1.93-5.308-2.2l-3.9-.292a4.11,4.11,0,0,1-2.4-.83,1.578,1.578,0,0,1-.7-1.369,2.523,2.523,0,0,1,.93-2.02,4.721,4.721,0,0,1,3.108-.785,9.794,9.794,0,0,1,3.448.561,14.647,14.647,0,0,1,2.881,1.593l2.926-3.388a13.886,13.886,0,0,0-3.9-2.356,14.74,14.74,0,0,0-2.427-.628,19.1,19.1,0,0,0-2.926-.2,10.243,10.243,0,0,0-6.216,1.8,6.285,6.285,0,0,0-2.563,5.385,5.962,5.962,0,0,0,1.951,4.645,7.988,7.988,0,0,0,4.832,1.975l4.174.359a4.086,4.086,0,0,1,2.11.561,1.916,1.916,0,0,1,.771,1.75,2.449,2.449,0,0,1-1.293,2.2,6.348,6.348,0,0,1-3.335.785A9.884,9.884,0,0,1,106.927,53.411Z",
    transform: "translate(-27.737 -6.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52566",
    "data-name": "Path 52566",
    d: "M139.761,55.632H144.5V41.764a4.913,4.913,0,0,1,1.339-3.725,4.574,4.574,0,0,1,3.357-1.3,4.5,4.5,0,0,1,3.335,1.3,4.963,4.963,0,0,1,1.316,3.725V55.632h4.741V40.149a7.857,7.857,0,0,0-2.518-6.059,8.128,8.128,0,0,0-5.354-2.042,7.639,7.639,0,0,0-6.125,2.76H144.5V22.916h-4.741Z",
    transform: "translate(-40.346 -2.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52567",
    "data-name": "Path 52567",
    d: "M176.15,55.632h4.742V32.34H176.15Zm0-28.026h4.742v-4.69H176.15Z",
    transform: "translate(-53.039 -2.103)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52568",
    "data-name": "Path 52568",
    d: "M191.359,60.524H196.1V46.656a4.868,4.868,0,0,1,1.362-3.725,4.5,4.5,0,0,1,3.334-1.3,4.576,4.576,0,0,1,3.358,1.3,5.012,5.012,0,0,1,1.293,3.725V60.524h4.741V46.656a4.913,4.913,0,0,1,1.339-3.725,4.575,4.575,0,0,1,3.357-1.3,4.5,4.5,0,0,1,3.335,1.3,5.012,5.012,0,0,1,1.293,3.725V60.524h4.742V45.041a7.794,7.794,0,0,0-2.5-6.059A8.128,8.128,0,0,0,216.4,36.94a9.327,9.327,0,0,0-7.418,3.052,11.75,11.75,0,0,0-2.7-2.222,8.868,8.868,0,0,0-3.947-.83,7.661,7.661,0,0,0-6.147,2.76H196.1V37.232h-4.741Z",
    transform: "translate(-58.344 -6.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52569",
    "data-name": "Path 52569",
    d: "M250.045,60.524h4.742V46.656a4.868,4.868,0,0,1,1.361-3.725,4.5,4.5,0,0,1,3.334-1.3,4.576,4.576,0,0,1,3.358,1.3,5.012,5.012,0,0,1,1.293,3.725V60.524h4.741V46.656a4.913,4.913,0,0,1,1.339-3.725,4.575,4.575,0,0,1,3.357-1.3,4.5,4.5,0,0,1,3.335,1.3,5.012,5.012,0,0,1,1.293,3.725V60.524h4.742V45.041a7.794,7.794,0,0,0-2.5-6.059,8.128,8.128,0,0,0-5.354-2.042,9.328,9.328,0,0,0-7.418,3.052,11.751,11.751,0,0,0-2.7-2.222,8.868,8.868,0,0,0-3.947-.83,7.661,7.661,0,0,0-6.147,2.76h-.091V37.232h-4.742Z",
    transform: "translate(-78.815 -6.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52570",
    "data-name": "Path 52570",
    d: "M325.955,50.651v-3.86a9.5,9.5,0,0,0-2.881-7.225,9.856,9.856,0,0,0-6.828-2.625,10.216,10.216,0,0,0-3.4.606,8.464,8.464,0,0,0-3.153,1.975,9.987,9.987,0,0,0-2.269,3.68,16.06,16.06,0,0,0-.885,5.744,14.209,14.209,0,0,0,1.021,5.834,9.238,9.238,0,0,0,2.428,3.635,8.346,8.346,0,0,0,1.656,1.055,8.891,8.891,0,0,0,1.724.785,12.393,12.393,0,0,0,3.629.538,11.159,11.159,0,0,0,8.484-3.77l-3.425-2.9A7.1,7.1,0,0,1,316.9,56.4a5.479,5.479,0,0,1-3.993-1.481,5.419,5.419,0,0,1-1.633-4.263Zm-14.677-3.86a6.172,6.172,0,0,1,1.474-4.106,5.272,5.272,0,0,1,6.988,0,5.884,5.884,0,0,1,1.474,4.106Z",
    transform: "translate(-98.519 -6.996)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52571",
    "data-name": "Path 52571",
    d: "M341.846,60.524h4.742V46.5a4.541,4.541,0,0,1,1.5-3.7,4.478,4.478,0,0,1,3.108-1.167,5,5,0,0,1,3.1,1.167l3.448-4.061a7.969,7.969,0,0,0-11.07.965h-.091V37.232h-4.742Z",
    transform: "translate(-110.836 -6.996)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShimmer);
export default __webpack_public_path__ + "static/media/shimmer.862f6ff240fb829dfbb9cd0ece69214d.svg";
export { ForwardRef as ReactComponent };